<template>
  <div class="modal">
    <h3>{{ reservation?.id ? 'Edit' : 'Create' }} Reservation</h3>
    <form @submit.prevent="handleSubmit">
      <input v-model="form.start_date" type="date" required />
      <input v-model="form.end_date" type="date" required />
      <select v-model="form.project_type" required>
        <option value="internal">Internal</option>
        <option value="external">External</option>
      </select>
      <input v-model="form.start_time" type="time" required />
      <input v-model="form.end_time" type="time" required />
      <input v-model="form.remarks" placeholder="Remarks" required />
      <input v-model.number="form.number_of_persons" type="number" min="1" required />
      <select v-model="form.status">
        <option value="pending">Pending</option>
        <option value="confirmed">Confirmed</option>
        <option value="cancelled">Cancelled</option>
      </select>

      <button type="submit">Save</button>
      <button @click.prevent="$emit('close')">Cancel</button>
    </form>
  </div>
</template>

<script setup>
import { reactive, watch, defineProps, defineEmits } from 'vue'
import { createReservation, updateReservation } from '@/services/trainingReservations'

const props = defineProps({
  reservation: Object,
})
const emit = defineEmits(['close', 'saved'])

const form = reactive({
  start_date: '',
  end_date: '',
  project_type: 'internal',
  start_time: '',
  end_time: '',
  remarks: '',
  number_of_persons: 1,
  status: 'pending',
})

watch(
  () => props.reservation,
  (val) => {
    if (val) {
      Object.assign(form, val)
    } else {
      Object.assign(form, {
        start_date: '',
        end_date: '',
        project_type: 'internal',
        start_time: '',
        end_time: '',
        remarks: '',
        number_of_persons: 1,
        status: 'pending',
      })
    }
  },
  { immediate: true }
)

const handleSubmit = async () => {
  if (props.reservation?.id) {
    await updateReservation(props.reservation.id, form)
  } else {
    await createReservation(form)
  }
  emit('saved')
  emit('close')
}
</script>
